import { defaultTo } from 'ramda';
import { IPaymentWidgetMethodResponse } from '../../../../repositories/billing-payments/entities/PaymentWidget/PaymentWidgetMethodResponse';
import { EPaymentProvider, EPaymentMethodType, IPaymentMethod } from '../../../../types/redux/paymentMethods';
import { mapLinkedCard } from './mapLinkedCard';
import { getIsEnumIncludes } from '../../../../utils/getIsEnumIncludes';

export const mapMethod = (method: IPaymentWidgetMethodResponse): IPaymentMethod | null => {
  const { name, minAmount, maxAmount, warning, linkedCard } = method;

  const type = method.type as string as EPaymentMethodType;

  if (!getIsEnumIncludes(EPaymentMethodType, type)) {
    return null;
  }

  const paymentProvider = method.paymentProvider as string as EPaymentProvider;

  if (!getIsEnumIncludes(EPaymentProvider, paymentProvider)) {
    return null;
  }

  return {
    type,
    name,
    paymentProvider,
    min: minAmount,
    max: defaultTo(undefined, maxAmount),
    warning: defaultTo(null, warning),
    linkedCard: mapLinkedCard(linkedCard),
  };
};
